import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAddCommentCreation, fetchCreationComments } from "../../Reducers/actions/creationsActions";

import "./CommentSection.scss";
import { useDraggableSheet } from "../../../helpers/hooks";
import Comment from "./Comment";
import { fetchAddCommentNews, fetchNewsComments } from "../../Reducers/actions/newsActions";
import ProfilePicture from "../ProfilePicture/ProfilePicture";
import Icon from "../Icon/Icon";
import CommentSkeleton from "./CommentSkeleton";

const CommentSection = ({ creation_id, onSend, onClose, type = 'creations' }) => {
    const isCreation = type === 'creations';

    const { user, comments, loadingComments } = useSelector(state => ({
        user: state.auth.user,
        comments: isCreation ? state.creation.comments || [] : state.news.comments || [],
        loadingComments: isCreation ? state.creation.loadingComments || false : false
    }))
    const [newComment, setNewComment] = useState("");
    const [inputFocused, setInputFocused] = useState(false);
    const [sheetHeight, setSheetHeight] = useState('90dvh');
    const commentsListRef = useRef(null);

    const dispatch = useDispatch();

    useEffect(() => {
        if (isCreation) {
            dispatch(fetchCreationComments(creation_id))
        } else {
            dispatch(fetchNewsComments(creation_id))
        }
    }, []);

    useEffect(() => {
        function updateHeight() {
            if (window.visualViewport) {
                setSheetHeight(`${window.visualViewport.height - 20}px`);
            } else {
                setSheetHeight(`${window.innerHeight - 20}px`);
            }
        }
        updateHeight();
        window.visualViewport?.addEventListener('resize', updateHeight);
        window.addEventListener('resize', updateHeight);
        return () => {
            window.visualViewport?.removeEventListener('resize', updateHeight);
            window.removeEventListener('resize', updateHeight);
        };
    }, []);

    const {
        // dragOffset,
        // dragging,
        sheetStyle,
        overlayHandlers
    } = useDraggableSheet({ onClose });

    const handleSend = () => {
        if (newComment.trim()) {
            if (onSend) onSend(newComment.trim());

            if (type === 'creations') dispatch(fetchAddCommentCreation({ creation_id, content: newComment }));
            else if (type === 'news') {
                dispatch(fetchAddCommentNews({ news_id: creation_id, content: newComment }));
            }
            setNewComment("");

            // Scroll to the top of comments list after adding new comment
            setTimeout(() => {
                if (commentsListRef.current) {
                    commentsListRef.current.scrollTop = 0;
                }
            }, 100);
        }
    };

    return (
        <div
            className="comment-section"
            {...overlayHandlers}
        >
            <div
                className={`sheet ${inputFocused ? "expanded" : ""}`}
                style={{ ...sheetStyle, maxHeight: sheetHeight }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="pull-bar" />
                <p className="d-flex jcc aic fs-xs fw-bold fg-grey9">Comments</p>

                <div className="comments-list" ref={commentsListRef}>
                    {loadingComments ? [1,2,3,4,5].map((item) => <CommentSkeleton key={item} />) :

                        comments.map((comment, idx) => (
                            <Comment key={idx} comment={comment} />
                        ))}

                </div>

                <div className="comment-input">
                    <ProfilePicture classNames={'avatar'} imgUrl={user?.profilePicture} no_edit={true} showIcon={false} width={32} height={32} />

                    <textarea
                        placeholder="Comment..."
                        value={newComment}
                        onChange={(e) => setNewComment(e.target.value)}
                        onFocus={() => setInputFocused(true)}
                        onBlur={() => setInputFocused(false)}
                        rows={1}
                        style={{
                            resize: 'none',
                            maxHeight: '120px',
                            overflowY: 'auto',
                            fontSize: '14px',
                            fontWeight: '500',
                            paddingRight: '52px'
                        }}
                    />
                    {(inputFocused || newComment.length > 0) && <button
                        className="btn red-btn send-btn d-flex aic jcc"
                        onClick={handleSend}
                    >
                        <Icon alias="arrow-right" stroke='#fff' width="20" color="#fff" />
                    </button>}
                    {/* <button
                        className="send-btn"
                        disabled={!newComment.trim()}
                        onClick={handleSend}
                    >
                        Post
                    </button> */}
                </div>
            </div>
        </div>
    );
};

export default CommentSection;
